import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createUser } from "../../api/apiUsers";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء مستخدم جديد
 */
export function useCreateUser() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createUserMutate,
        isPending,
    } = useMutation({
        mutationFn: createUser,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
            navigate('/users');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create user");
        },
    });

    return {
        createUserMutate,
        isPending,
    };
}